module.exports = __webpack_public_path__ + "img/pro_thirteen_1.56051882.jpg";